import Component from '@glimmer/component'
import type { UIScopeName } from 'teacher-ui-client/reporting/ui-scope/route'
import type { CourseProgressHistoryReportData } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/history/report-loader'
import { CourseProgressHistoryTable } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/history/table'
import { CourseProgressHistoryChart } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/history/chart'
import { BasePageSelector as PageSelector } from 'teacher-ui-client/components/base/page-selector'

interface Signature {
  Args: {
    isReloading?: boolean
    scopeName: UIScopeName
    reportData: CourseProgressHistoryReportData
  }
}

export class CourseProgressHistoryReport extends Component<Signature> {
  get showChart() {
    return this.args.scopeName !== 'school'
  }

  <template>
    <div class="flex overflow-x-auto print:block print:max-h-[unset] print:overflow-visible">
      <CourseProgressHistoryTable
        @isReloading={{@isReloading}}
        class="{{if this.showChart 'w-1/2' 'w-full'}} border-dusty-black-200 border-b print:w-full"
        @studentsReportData={{@reportData.students}}
      />
      {{#if this.showChart}}
        <CourseProgressHistoryChart
          class="{{if @isReloading 'opacity-50'}} border-dusty-black-200 w-1/2 border-b print:hidden"
          @studentsReportData={{@reportData.students}}
        />
      {{/if}}
    </div>
    <PageSelector
      class="mx-2 py-3"
      @pageCount={{@reportData.meta.total_pages}}
      @itemCount={{@reportData.meta.total_entries}}
    />
  </template>
}
